<template>
<div class="modal fade" id="modalChangeContactPhoneFunil" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h4 class="title-modal">Alterar Contato.</h4>
      </div>

      <div class="modal-body">
        <form>
          <div class="form-group owner-select">
            <label>Nome do Contato</label>
            <input v-model="dataModalChange.contactName" type="text" class="form-control" name="contactName" required>
            <span v-if="error.contactName" class="error-msg">{{error.contactName}}</span>
          </div>

          <div class="form-group">
            <label>E-mail de contato</label>
            <input v-model="dataModalChange.contactEmail" type="text" class="form-control" name="contactEmail" required>
            <span v-if="error.contactEmail" class="error-msg">{{error.contactEmail}}</span>
          </div>

          <div class="form-group">
            <label>Telefone Primario</label>
            <input v-model.lazy="dataModalChange.primaryTelephone" v-mask="['(##) ####-####', '(##) #####-####']" type="text" class="form-control" id="primaryTelephone" name="primaryTelephone" />
            <span v-if="error.primaryTelephone" class="error-msg">{{error.primaryTelephone}}</span>
          </div>

          <div class="form-group">
            <label>Telefone Secundario</label>
            <input v-model.lazy="dataModalChange.secundaryTelephone" v-mask="['(##) ####-####', '(##) #####-####']" type="text" class="form-control" id="secundaryTelephone" name="secundaryTelephone" />
            <span v-if="error.secundaryTelephone" class="error-msg">{{error.secundaryTelephone}}</span>
          </div>

        </form>
      </div>

      <div class="modal-footer">
        <button v-on:click="changeEmployeer()" :disabled="loadingChange" v-bind:class="{'disable': loadingChange}" type="submit" class="btn btn-register">
          <span v-if="!loadingChange">Enviar</span>
          <div class="loading-btn" v-else>
            <div class="spinner-btn">
              <div class="rect1"></div>
              <div class="rect2"></div>
              <div class="rect3"></div>
              <div class="rect4"></div>
              <div class="rect5"></div>
            </div>
          </div>
        </button>
        <button v-on:click="closeModal()" class="close-btn">Fechar</button>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import {
  CHANGE_BUSINESS_CONTACT
} from "../../../urlConfig";
import {
  REQUEST_SERVICE
} from "../../../requestConfig";
import {
  UTIL_SERVICE
} from "../../../requestConfig";
import {
  ALERT_SERVICE
} from "../../../msgAlertService";

export default {
  name: "modalChangeContactPhoneFunil",
  props: ['objRS'],
  watch: {
    objRS: function (val) {
      this.dataModalChange.contactName = val.contacts.contactName;
      this.dataModalChange.contactEmail = val.contacts.contactEmail;
      this.dataModalChange.primaryTelephone = val.contacts.primaryTelephone;
      this.dataModalChange.secundaryTelephone = val.contacts.secundaryTelephone;
    }
  },
  data() {
    return {
      companyId: this.$route.params.idCompany,
      contextModal: this.$route.params.context,
      error: {
        contactName: '',
        contactEmail: '',
        primaryTelephone: '',
        secundaryTelephone: ''
      },
      dataModalChange: {
        contactName: '',
        contactEmail: '',
        primaryTelephone: '',
        secundaryTelephone: ''
      },
      loadingChange: false
    }
  },
  methods: {
    closeModal() {
      $('#modalChangeContactPhoneFunil').modal('toggle');
    },
    changeEmployeer() {
      this.error.contactName = "";
      this.error.contactEmail = "";

      if (this.dataModalChange.contactName /* && this.dataModalChange.contactEmail */ ) {
        if (!this.loadingChange) {
          this.loadingChange = true;
          let obj = {
            userId: JSON.parse(window.localStorage.getItem('mamUserMasterInfo')).id,
            pipelineId: this.$route.params.idPipe,
            pipelineBusinessId: this.$route.params.idBusiness,
            contactName: this.dataModalChange.contactName,
            contactEmail: this.dataModalChange.contactEmail,
            primaryTelephone: this.dataModalChange.primaryTelephone,
            secundaryTelephone: this.dataModalChange.secundaryTelephone
          };

          UTIL_SERVICE.console("DATA SEND:", obj);
          REQUEST_SERVICE.post(CHANGE_BUSINESS_CONTACT, obj).then((response) => {
            UTIL_SERVICE.console("RESULT CHANGE_BUSINESS_CONTACT:", response);

            this.objRS.contacts.contactName = this.dataModalChange.contactName;
            this.objRS.contacts.contactEmail = this.dataModalChange.contactEmail;
            this.objRS.contacts.primaryTelephone = this.dataModalChange.primaryTelephone;
            this.objRS.contacts.secundaryTelephone = this.dataModalChange.secundaryTelephone;

            this.loadingChange = false;
            $('#modalChangeContactPhoneFunil').modal('toggle');

            ALERT_SERVICE.swal("Aviso", response.data, "success");
          }).catch((reason) => {
            this.loadingChange = false;
            $('#modalChangeContactPhoneFunil').modal('toggle');

            ALERT_SERVICE.showMsgError(reason.response.data.erros);
          });
        }
      } else {
        if (!this.dataModalChange.contactName)
          this.error.contactName = "Preencha um nome de contato";

        if (!this.dataModalChange.contactEmail)
          this.error.contactEmail = "Preencha um email de contato.";
      }
    }
  }
}
</script>

<style lang="scss">
#modalChangeContactPhoneFunil {
  .owner-select {
    width: 100%;

    select {
      border: 1px solid #999;
      border-radius: 5px;
      height: 34px;
      width: 100%;
      padding: 0 10px;
      cursor: pointer;
    }
  }

  .select-date {
    width: 100%;
    margin-top: 20px;

    p {
      font-size: 18px;
      padding-left: 1px;
    }

    .vdp-datepicker {
      display: inline-block;
      width: 100%;

      input {
        border: 1px solid #999;
        border-radius: 5px;
        height: 34px;
        width: 100%;
        padding: 0 10px;
        cursor: pointer;
      }
    }

    i {
      display: inline-block;
      position: relative;
      right: 15px;
      top: -23px;
      float: right;
      color: #111;
      cursor: pointer;
    }
  }

  .error-msg {
    font-size: 12px;
    color: #e74a4e;
    text-align: left;
    display: block;
  }

  .modal-header {
    padding: 15px 15px 0;
    border-bottom: none;
  }

  .modal-body {
    padding-left: 80px;
    padding-right: 80px;
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .title-modal {
    text-align: center;
    padding-top: 10px;
    font-weight: bold;
    letter-spacing: 1px;
    text-transform: uppercase;
  }

  .modal-footer {
    .close-btn {
      border-radius: 4px !important;
      background-color: #8b8787;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }

    .btn-register {
      border-radius: 4px !important;
      background-color: #3598dc;
      padding: 7px 35px 7px 35px;
      font-weight: 600;
      text-align: center;
      color: #fff;
      border: none;
      height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/modals/modalChangeContactPhoneFunil.vue